import styled, {css} from 'styled-components'

import Utils from 'live/lib/utils'
import theme from 'live/services/theme'

export const TemplateContainer = styled.section`
    display: flex;
    width: 100%;
    height: 600px;

    ${Utils.isMobile()
        ? css`
              height: calc(100% - 50px);
              background: ${theme['gray-lighter']};

              > div {
                  flex-direction: column;
                  height: 100%;
              }
          `
        : css`
              height: 100%;
              background: white;

              > div {
                  height: 100%;
              }
          `};
    > div {
        display: flex;
        width: 100%;
        max-width: 100%;
        flex: 1;
        min-height: 0;
    }
`
